import {RouteDefinition, Router} from '@solidjs/router'
import {useSelector} from '../store'
import {createEffect, createSignal, Show} from 'solid-js'
import {Spinner} from '../components'

export interface RouterWrapperProps {
    getRoutes: (indexRoute?: string) => RouteDefinition[]
}

export function RouterWrapper(props: RouterWrapperProps) {
    const [indexRoute, setIndexRoute] = createSignal<string>()
    const state = useSelector((state: any) => state)

    const getIndexRoute = modules => {
        if (modules) {
            const homeModule: any = Object.keys(modules)?.find((m: any) => !!modules[m].isHomePage)
            const fallbackModule: any = Object.keys(modules)?.find((m: any) => !!modules[m].name)
            return homeModule ? `root-${homeModule}` : `root-${fallbackModule}`
        }
        return null
    }

    createEffect(() => {
        const modules = state()?.emi?.config?.modules
        const newIndexRoute = getIndexRoute(modules)

        if (newIndexRoute) {
            setIndexRoute(newIndexRoute)
        }
    })

    return <Router>{props.getRoutes(indexRoute())}</Router>
}
